import { displayMissedChallengeNotifications } from "./matchmaking";

export const WINDOW_GET_FOCUS = 'WINDOW_GET_FOCUS';
export const WINDOW_LOSE_FOCUS = 'WINDOW_LOSE_FOCUS';
export const WINDOW_GET_VISIBILITY = 'WINDOW_GET_VISIBILITY';
export const WINDOW_LOSE_VISIBILITY = 'WINDOW_LOSE_VISIBILITY';
export const CONNECTION_ONLINE = 'CONNECTION_ONLINE';
export const CONNECTION_OFFLINE = 'CONNECTION_OFFLINE';

export const AUDIO_SUCCESS = 'AUDIO_SUCCESS';
export const AUDIO_ERROR_HAPPENED = 'AUDIO_ERROR_HAPPENED';
export const AUDIO_ERROR_ACKNOWLEDGED = 'AUDIO_ERROR_ACKNOWLEDGED';


export const connectionIsOnline = () => {
	return {
		type: CONNECTION_ONLINE
	};
};
export const connectionIsOffline = () => {
	return {
		type: CONNECTION_OFFLINE
	};
};
export const windowFocusChanged = (isFocused) => {
	return {
		type: isFocused ? WINDOW_GET_FOCUS : WINDOW_LOSE_FOCUS
	};
};
export const windowVisibilityChanged = (isVisible) => (dispatch) => {
	if(isVisible) {
		dispatch(displayMissedChallengeNotifications());

		dispatch({
			type: WINDOW_GET_VISIBILITY
		});
	}
	else {
		dispatch({
			type: WINDOW_LOSE_VISIBILITY
		});
	}
};

export const windowAudioError = () => {
	return {
		type: AUDIO_ERROR_HAPPENED
	};
};
export const windowAudioSuccess = () => {
	return {
		type: AUDIO_SUCCESS
	};
};

export const windowAudioErrorAcknowledged = () => {
	return {
		type: AUDIO_ERROR_ACKNOWLEDGED
	};
};


